export const compare = (obj, key, isAsc) => {
    obj.sort((a, b) => {
        if (a[key] < b[key])
            return isAsc ? -1 : 1;
        if (a[key] > b[key])

            return isAsc ? 1 : -1;
        return 0;
    })
}